document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.custom-video-player').forEach(function (player) {

    const video = player.querySelector('video');
    const playButton = player.querySelector('.custom-video-play');
    const progress = player.querySelector('.custom-video-progress');
    const progressBar = player.querySelector('.custom-video-progress-bar');

    if (!video || !playButton) return;

    // Play / Pause
    playButton.addEventListener('click', function () {

      if (video.paused) {

        video.play();
        player.classList.add('is-playing');

      } else {

        video.pause();
        player.classList.remove('is-playing');

      }

    });

    // Update progress bar
    video.addEventListener('timeupdate', function () {

      if (!video.duration) return;

      const percentage =
        (video.currentTime / video.duration) * 100;

      progressBar.style.width = percentage + '%';

    });

    // Click progress bar to seek
    progress.addEventListener('click', function (event) {

      const rect = progress.getBoundingClientRect();

      const clickPosition =
        (event.clientX - rect.left) / rect.width;

      video.currentTime =
        clickPosition * video.duration;

    });

    // Video ended
    video.addEventListener('ended', function () {

      player.classList.remove('is-playing');

      progressBar.style.width = '100%';

    });

  });

});